const API_PATHS = {
    BASE_URL: 'https://staging-api.danileeshelpinghnds.org/',
    LOGIN_API: 'v1/parent/login',
    GET_ALL_LOCATIONS_API: 'v1/location/get-All-Locations',
    EVENT_SERVICES: 'v1/location/event-services',
    GET_ALL_KIDS_API: 'v1/parent/get-All-Kids',
    EDIT_KID: 'v1/parent/edit-kid-details',
    GET_ALL_PLANS: 'v1/booking/plans',
    CREATE_KIDS: "v1/parent/create-kid",
    GET_ALL_ADDRESS: 'v1/parent/get-All-addresses',
    SAVE_RECURRING: 'v1/booking/create-recurring',
    PROFILE_API: 'v1/parent/get-parents-details',
    EDIT_PARENT_DETAILS: 'v1/staff/edit-parent-details',
    CREATE_ADDRESS: 'v1/parent/create-address',
    TERMS_CONDITIONS: 'v1/others/tc',
    EVENT_DETAILS: 'v2/event/event',
    GET_EVENT_DETAILS: 'v2/event/user-get-event',
    REGISTRATION_DETAILS: 'v2/registration/registration/details',
    REGISTER_EVENT: 'v2/registration/register-event',
    REGISTER_FOR_EVENT: 'v2/registration/register-for-event',
    EDIT_EVENT_REGISTRATION: 'v2/registration/edit-event-registration',
    GENERATE_EVENT_TICKET_QR: 'v2/ticket/generate-event-ticket-qr',
    GET_USER_EVENTS: 'v2/event/user-events',
    GET_ALL_EVENTS: 'v2/event/user-get-all-events',
    CALENDAR_DATA: 'v1/booking/new-calander-data',
    EDIT_BOOKING: 'v1/booking/edit-booking',
    GET_BOOKING_DETAILS: 'v1/booking/get-booking-details',
    GET_BOOKINGS: 'v1/booking/getBookings',
    GET_BOOKINGS2: 'v1/booking/getBookings2',
    GET_INVOICES: 'v1/booking/get-invoices',
    GET_NOTIFICATIONS: 'v1/notification/get-notifications',
    GET_ALL_RECURRINGS: 'v1/booking/get-all-recurrings',
    GET_ALL_RECURRINGS2: 'v1/booking/get-all-recurrings2',
    RECURRING_DETAILS: 'v1/booking/recurring-booking-details',
    CREATE_PARENT: 'v1/parent/create-parent',
    GET_INVOICE: 'v1/booking/get-invoice',
    GET_OTHER_INVOICE: 'v1/booking/get-other-invoices',
    UPLOAD_FILE: 'v1/staff/upload-file',
    CREATE_RECURRING: 'v1/booking/create-recurring',
    CREATE_RECURRING_SOCIALHUB: 'v1/booking/create-recurring-socialhub',
    CREATE_BOOKING: 'v1/booking/create-booking',
    GET_PARENTS: 'v1/staff/get-parents',
    GENERATE_PARENT_TOKEN: 'v1/staff/generate-parent-token',
    CANCEL_BOOKING: 'v1/booking/cancel-booking',
    UPDATE_FAMILY: 'v1/parent/update-family',
    FETCH_FAMILY: 'v1/parent/fetch-family',
    INVITE_FAMILY_MEMBER: 'v1/parent/invite-family-member',
    REMOVE_FAMILY_MEMBER: 'v1/parent/remove-family-member',
    LEAVE_FAMILY: 'v1/parent/leave-family',
    IS_CHAT_ALLOWED: 'v1/booking/is-chat-allowed',
    CHAT_URL: 'http://staging-admin.danileeshelpinghnds.org/chat',
}
export default API_PATHS
